module.exports = __webpack_public_path__ + "img/usage-rate-bg.722bfd0d.png";